module.exports = __webpack_public_path__ + "static/img/9a31426498dca2e292a8af24f8c12644.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_01.png
// module id = Q0fz
// module chunks = 1